import React, { useState } from "react";
import { Avatar, Card, Grid, Icon, InputText, Link, Text } from "~/components-shared";
import { useTranslation } from "react-i18next";
import { RoutesEnum } from "~/types/enums";
import { useHistory } from "react-router-dom";
import styled, { useTheme } from "styled-components";
import { useSelector } from "react-redux";
import authSelectors from "~/store/auth/selectors";
const StyledGrid = styled(Grid)`
  max-height: 300px;
  overflow: auto;
`;
const TopicSummaryFollowersCard = _ref => {
  let {
    followers,
    initialLimit = 3,
    ...rest
  } = _ref;
  const {
    colors
  } = useTheme();
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const [limit, setLimit] = useState(initialLimit);
  const [query, setQuery] = useState("");
  const user = useSelector(authSelectors.getUser);
  let tempFollowers = followers;
  const exceededLimit = followers.length > initialLimit;
  const exceededLimitBy = limit && followers.length > limit ? followers.length - limit : undefined;
  if (exceededLimitBy) {
    tempFollowers = followers.slice(0, limit);
  }
  const toggleLimit = () => {
    setLimit(prev => prev ? undefined : initialLimit);
    setQuery("");
  };
  const handleMemberClick = id => {
    history.push(user.id === id ? RoutesEnum.PROFILE : RoutesEnum.MEMBER.replace(":memberId", id));
  };
  const filteredFollowers = tempFollowers.filter(_ref2 => {
    let {
      firstName,
      lastName
    } = _ref2;
    return query === "" || `${firstName} ${lastName}`.toLowerCase().includes(query.toLowerCase());
  });
  return /*#__PURE__*/React.createElement(Card, rest, exceededLimit && !exceededLimitBy && /*#__PURE__*/React.createElement(InputText, {
    autoFocus: true,
    value: query,
    onChange: val => setQuery(val),
    elemBefore: /*#__PURE__*/React.createElement(Icon, {
      src: "search",
      s: {
        mr: 2
      }
    }),
    placeholder: t("common.actions.search"),
    fullWidth: true,
    clearButton: true,
    s: {
      mb: 4
    }
  }), filteredFollowers.length ? /*#__PURE__*/React.createElement(StyledGrid, {
    cols: 3,
    gap: 4,
    template: "2.3rem 1fr"
  }, filteredFollowers.map(follower => {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: follower.id
    }, /*#__PURE__*/React.createElement(Avatar, {
      user: follower,
      size: 9
    }), /*#__PURE__*/React.createElement(Grid.Cell, {
      align: "center"
    }, /*#__PURE__*/React.createElement(Link, {
      onClick: () => handleMemberClick(follower.id),
      fontSize: 4,
      weight: "semiBold",
      color: colors.text.primary,
      display: "block"
    }, follower.firstName, " ", follower.lastName), /*#__PURE__*/React.createElement(Text, {
      color: "textSecondary",
      weight: "semiBold"
    }, follower.email)));
  })) : /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    weight: "semiBold",
    fontSize: 4
  }, "No followers"), exceededLimit && /*#__PURE__*/React.createElement(Link, {
    onClick: toggleLimit,
    s: {
      mt: 2
    },
    weight: "semiBold",
    color: colors.text.secondary,
    underline: true
  }, exceededLimitBy ? `Show ${exceededLimitBy} more` : "Collapse list"));
};
export default TopicSummaryFollowersCard;